import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grow,
  Box,
} from "@material-ui/core";
import WebpageIcon from "@material-ui/icons/WebAsset";
import { useHistory } from "react-router-dom";

const LinkCard = ({ title, logo, url, type, subtitle }) => {
  const history = useHistory();
  const [hover, setHover] = useState(false);

  const onClick = () => {
    url = url.match(/^http[s]?:\/\//) ? url : "http://" + url;
    switch (type) {
      case "open":
        window.open(url, "_blank");
        break;
      case "redirect":
        window.location.href = url;
        break;
      default:
        history.push("/open?url=" + url);
        break;
    }
  };

  return (
    <Grow in={true} timeout={1000}>
      <Box
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={onClick}
        width="100%"
      >
        <Card elevation={hover ? 6 : 2} style={{ width: "100%" }}>
          <CardActionArea>
            {logo ? (
              <CardMedia
                component="img"
                height="120"
                image={logo}
                title={title}
                style={{
                  transform: `${hover ? "scale(1.0)" : "scale(0.9)"}`,
                  transition: "0.3s",
                  objectFit: "contain",
                  pointerEvents: "none",
                  paddingTop: 20,
                  paddingBottom: 10,
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              />
            ) : (
              <Box
                height={120}
                p={5}
                style={{
                  textAlign: "center",
                  fontSize: 60,
                  transform: `${hover ? "scale(1.0)" : "scale(0.9)"}`,
                  transition: "0.3s",
                  objectFit: "contain",
                  pointerEvents: "none",
                }}
              >
                <WebpageIcon color="primary" fontSize="inherit" />
              </Box>
            )}
            <CardContent>
              <Typography
                variant="h6"
                color={hover ? "primary" : "textPrimary"}
                noWrap
              >
                {title}
              </Typography>
              <Typography
                variant="body2"
                color={"textSecondary"}
                noWrap={hover ? false : true}
              >
                {subtitle}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Grow>
  );
};

LinkCard.defaultProps = {
  title: "Title",
  url: "https://",
};

export default LinkCard;
